import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectBulkUploadInstructionModalAnalyticIds = {
  ascProjectBulkUploadCancelBtnId: string;
  ascProjectBulkUploadUploadBtnId: string;
};

export const useAscProjectBulkUploadInstructionModalAnalyticIds =
  (): AscProjectBulkUploadInstructionModalAnalyticIds => ({
    ascProjectBulkUploadCancelBtnId: useAnalyticId(
      AnalyticIdentifier.ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_CANCEL_BUTTON,
    ),
    ascProjectBulkUploadUploadBtnId: useAnalyticId(
      AnalyticIdentifier.ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_UPLOAD_BUTTON,
    ),
  });
